import React from 'react';
import { motion } from 'framer-motion';
import { Star, MessageCircle } from 'lucide-react';
const testimonials = [{
  initial: 'M',
  color: 'bg-pink-100 text-pink-700',
  name: 'Martín G.',
  location: 'Técnico en HyS — Buenos Aires',
  text: 'Tenía que capacitar el lunes a las 8 AM y el domingo a la noche todavía no tenía las diapositivas. Con el Sistema Maestro abrí el capítulo correspondiente, adapté dos cosas al rubro y en 20 minutos tenía todo listo. Nunca más volví a improvisar.'
}, {
  initial: 'C',
  color: 'bg-blue-100 text-blue-700',
  name: 'Carolina R.',
  location: 'Licenciada en HyS — Córdoba',
  text: 'El bloque de riesgos críticos solo ya valió todo. Por fin tengo material sólido para trabajo en altura y espacios confinados que resiste cualquier auditoría. Los registros son completos y tienen todo lo que la ART necesita ver.'
}, {
  initial: 'D',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'Diego T.',
  location: 'Técnico en HyS — Rosario',
  text: 'Los cronogramas del Bono 4 me cambiaron la vida. Antes llevaba el año en la cabeza y siempre se me pasaba algo. Ahora tengo todo en un tablero, sé qué vence, qué falta y qué tengo que llevar a cada visita.'
}, {
  initial: 'P',
  color: 'bg-amber-100 text-amber-700',
  name: 'Paula B.',
  location: 'Licenciada en HyS — Mendoza',
  text: 'Las dinámicas del Bono 3 me salvaron con un grupo de operarios que no querían saber nada con las capacitaciones. Usé el rompehielos de percepción de riesgos y en 10 minutos estaban todos enganchados. Nunca me había sentido tan seguro dando una charla.'
}];
export function TestimonialsBottom() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-211">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-212">
        <div className="text-center mb-12 flex flex-col items-center" data-id="element-213">
          <MessageCircle className="w-10 h-10 text-[#d4a017] mb-4" data-id="element-214" />
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#2f3a2c]" data-id="element-215">
            Lo que otros profesionales de HyS están diciendo
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-216">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200 flex flex-col h-full" data-id="element-217">
              <div className="flex text-[#d4a017] mb-4" data-id="element-218">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-219" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-6 italic flex-grow" data-id="element-220">
                "{t.text}"
              </p>

              <div className="flex items-center border-t border-slate-100 pt-4 mt-auto" data-id="element-221">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${t.color} mr-3 flex-shrink-0`} data-id="element-222">
                  {t.initial}
                </div>
                <div data-id="element-223">
                  <div className="font-bold text-[#2f3a2c] text-sm" data-id="element-224">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-225">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}